import React, { useState } from "react";
import moment from "moment";
import "./style.css";

const Tracking = () => {
  const [time, setTime] = useState("");
  setInterval(() => {
    setTime(moment().format("MMMM Do YYYY, h:mm:ss a"));
  }, 1000);
  return (
    <div>
      <div style={{ backgroundColor: "#ecf0f5" }}>
        <div className="title_section">
          <div>
            <h3>Trail for documents track # : 22-1197</h3>
          </div>
          <div>
            <ul>
              <li className="nav_items">
                <i className="fas fa-home-alt"></i>Home
              </li>
              <li className="nav_items">{">"}</li>
              <li className="nav_items">Dashboard</li>
              <li className="nav_items">{">"}</li>
              <li className="nav_items">{time}</li>
            </ul>
          </div>
        </div>
        <center>
          {" "}
          <div className="tracking_table">
            <table>
              <tr>
                <th>Document Type</th>
                <th>Application Documents</th>
              </tr>
              <tr>
                <th>Description</th>
                <th>Standing list for Biding</th>
              </tr>
              <tr>
                <th>Origin</th>
                <th>Prakash Shrestha(Bigo Information Technology)</th>
              </tr>
              <tr>
                <th></th>
                <th>
                  <a href="http://">
                    <p style={{ float: "right", fontWeight: "400" }}>Edit</p>
                  </a>
                </th>
              </tr>
            </table>
          </div>
        </center>
        <div>
          <div className="tracking-box-wrapper">
            <p className="arrow"></p>
            <div className="tracking-box">
              <div style={{ textAlign: "center" }}>
                <p>Route ID: 2754</p>
                <p>Receiving Office</p>
                <p>Received by: Receiver | 07/03/22 @ 10:33 PM</p>
                <p>Actions Taken: I have checked it please, check it</p>
                <p>Forwarded to Store</p>
              </div>
            </div>
            <p className="arrow"></p>
            <div className="tracking-box">
              <div style={{ textAlign: "center" }}>
                <p>Route ID: 2754</p>
                <p>Receiving Office</p>
                <p>Received by: Receiver | 07/03/22 @ 10:33 PM</p>
                <p>Actions Taken: I have checked it please, check it</p>
                <p>Forwarded to Store</p>
              </div>
            </div>
            <p className="arrow"></p>
            <div className="tracking-box">
              <div style={{ textAlign: "center" }}>
                <p>Route ID: 2754</p>
                <p>Receiving Office</p>
                <p>Received by: Receiver | 07/03/22 @ 10:33 PM</p>
                <p>Actions Taken: I have checked it please, check it</p>
                <p>Forwarded to Store</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tracking;
